import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { UploadCloud, Loader2 } from "lucide-react";

// Uploads an image file to object storage and returns the public URL via onUpload(url).
export default function ImageUploader({ onUpload, label = "Upload image", testid = "image-uploader" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFiles = async (files) => {
    const list = Array.from(files || []);
    if (!list.length) return;
    setBusy(true);
    try {
      for (const file of list) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        onUpload(data.url);
      }
      toast.success(list.length > 1 ? `${list.length} images uploaded` : "Image uploaded");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div
      data-testid={testid}
      onClick={() => !busy && inputRef.current?.click()}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); handleFiles(e.dataTransfer.files); }}
      className="cursor-pointer border border-dashed border-white/20 hover:border-vorna-accent transition-colors p-4 flex items-center justify-center gap-2 text-xs tracking-widest text-white/50 hover:text-white"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UploadCloud className="h-4 w-4" />}
      {busy ? "UPLOADING…" : label.toUpperCase()}
      <input ref={inputRef} type="file" accept="image/*" multiple hidden onChange={(e) => handleFiles(e.target.files)} />
    </div>
  );
}
